import { Component } from '@angular/core';
import DatatableExtension from '@app/datatables/decorators/datatable-extension.decorator';
import { DatatablePagination } from '@app/shared/components/datatable-pagination';

declare module 'datatables.net' {
  interface Feature {
    pagination?: boolean;
  }
}

@Component({
  selector: 'portal-datatable-pagination',
  templateUrl: './datatable-pagination.component.html',
  host: {
    class: 'w-100',
  },
  standalone: false,
})
@DatatableExtension({
  componentElement: '<portal-datatable-pagination></portal-datatable-pagination>',
  key: 'P',
  name: 'pagination',
})
export class DatatablePaginationComponent extends DatatablePagination {}
